export default {
    indexBranches:   { method: 'get',    url: 'branches' },
}